import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button/button.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { InputComponent } from './input/input.component';
import { SelectComponent } from './select/select.component';
import { IconComponent } from './icon/icon.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CardComponent } from './card/card.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatPaginatorModule } from '@angular/material/paginator';

import { LoaderComponent } from './loader/loader.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { InputSearchComponent } from './input-search/input-search.component';
import { TitleComponent } from './title/title.component';
import { AlertComponent } from './alert/alert.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { UserComponent } from './user/user.component';
import { SearchComponent } from './search/search.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { TableComponent } from './table/table.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { SlideComponent } from './slide/slide.component';
import { FilterResumeComponent } from './filter-resume/filter-resume.component';
import { AccordionComponent } from './accordion/accordion.component';
import { MapComponent } from './map/map.component';
import { ChipComponent } from './chip/chip.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { FileUploadComponent } from './file-upload/file-upload.component';

const MATERIAL_MODULES = [
  MatInputModule,
  MatFormFieldModule,
  MatIconModule,
  MatSelectModule,
  MatCheckboxModule,
  MatMenuModule,
  MatAutocompleteModule,
  MatDialogModule,
  MatChipsModule,
  MatTableModule,
  MatPaginatorModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatTooltipModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatRadioModule,
];

const WEB_COMPONENTS = [
  ButtonComponent,
  InputComponent,
  IconComponent,
  SelectComponent,
  CheckboxComponent,
  CardComponent,
  LoaderComponent,
  SidebarComponent,
  InputSearchComponent,
  TitleComponent,
  AlertComponent,
  FooterComponent,
  HeaderComponent,
  UserComponent,
  SearchComponent,
  AutocompleteComponent,
  TableComponent,
  DisclaimerComponent,
  SlideComponent,
  FilterResumeComponent,
  AccordionComponent,
  MapComponent,
  ChipComponent,
  RadioButtonComponent,
  FileUploadComponent
];

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, ...MATERIAL_MODULES],
  exports: [...MATERIAL_MODULES, ...WEB_COMPONENTS],
  declarations: [...WEB_COMPONENTS ],
  providers: [
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    { provide: MatDialogRef, useValue: {} },
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class UiModule {}
